export default __webpack_public_path__ + "static/media/1.1f91e2e0.png";